"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  transition: transform 0.5s;\n"], ["\n  margin-left: 10px;\n  transition: transform 0.5s;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: "Arrow__Wrapper",
  componentId: "sc-131lyhc-0"
})(_templateObject);

var Arrow = function Arrow() {
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      "svg",
      { width: "14px", height: "12px", viewBox: "0 0 14 12", version: "1.1" },
      _react2.default.createElement(
        "g",
        {
          id: "180418",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        },
        _react2.default.createElement(
          "g",
          {
            id: "1_HP-D",
            transform: "translate(-693.000000, -2641.000000)",
            stroke: "#FFFFFF",
            strokeWidth: "1.25"
          },
          _react2.default.createElement(
            "g",
            { id: "Group-20", transform: "translate(543.000000, 2625.000000)" },
            _react2.default.createElement(
              "g",
              { id: "Group-16", transform: "translate(28.000000, 11.000000)" },
              _react2.default.createElement(
                "g",
                {
                  id: "Icon-:-arrow-right",
                  transform: "translate(129.500000, 11.000000) scale(-1, 1) rotate(-180.000000) translate(-129.500000, -11.000000) translate(123.000000, 6.000000)"
                },
                _react2.default.createElement("polygon", {
                  id: "Stroke-52",
                  points: "12.3191745 4.95416681 7.33858549 -4.97379915e-15"
                }),
                _react2.default.createElement("path", {
                  d: "M0.433333333,4.95416681 L11.8392086,4.95416681",
                  id: "Stroke-54"
                }),
                _react2.default.createElement("path", {
                  d: "M12.3191745,4.95416681 L7.33858549,9.90833362",
                  id: "Stroke-56"
                })
              )
            )
          )
        )
      )
    )
  );
};

exports.default = Arrow;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-button/dist/images/Arrow.js
// module id = 393
// module chunks = 168707334958949